import * as types from './actionTypes';
import * as browserCheck from '../utils/browserCheck.js';

export function showModal(type){
    return function(dispatch) {
        const modalType = type;
        dispatch({ type: types.SHOW_MODAL, modalType });
        if(browserCheck.canUseDom()) {
            $('body').addClass('modal-open');
        }
    };
}

export function hideModal(){
    return function(dispatch) {
        dispatch({ type: types.HIDE_MODAL });
        if(browserCheck.canUseDom()) {
            $('body').removeClass('modal-open');
        }
    };
}